import { useAdminUpdate } from '@reapitform/hooks'
import { AdminFormVersionPayload, AdminFormVersionResponse } from '../types'

/**
 * Updates a form version (`PUT /api/forms/{formReferenceID}/versions/{versionReferenceID}`). Carries the
 * single success toast for the combined form + version edit.
 */
export const useUpdateAdminFormVersion = (formReferenceID: string, versionReferenceID: string) =>
  useAdminUpdate<AdminFormVersionPayload, AdminFormVersionResponse>({
    path: `/api/forms/${formReferenceID}/versions/${versionReferenceID}`,
    method: 'PUT',
    errorMessage: 'Failed to update the version',
    successMessage: 'Form updated',
  })
